function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { matchSorter } from 'match-sorter';
import { Autocomplete, Typography } from 'seagull';
import { Plus } from 'seagull/icons';
import { newClientText, OptionType } from "./AccountingCustomerDropdown.utils";
import { getAccountingDetails } from "../accounting.utils";
import styles from "./AccountingCustomerDropdown.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function AccountingCustomerDropdown(props) {
  const {
    accountingCustomers,
    value,
    onChange,
    textFieldProps = {},
    loading = false,
    disabled = false,
    onInputFocus,
    onInputBlur,
    accounting
  } = props;
  const createNewOption = {
    type: OptionType.CreateNew
  };
  const {
    testIdPrefix,
    name
  } = getAccountingDetails(accounting);
  const onAccountingCustomerChange = newOption => {
    onChange && onChange(newOption);
  };
  return /*#__PURE__*/_jsx(Autocomplete, {
    "data-testid": "".concat(testIdPrefix, "-customer-dropdown"),
    value: value,
    options: [],
    lazyOptions: () => {
      const options = accountingCustomers.map(c => ({
        type: OptionType.Existing,
        customer: c
      }));
      options.unshift(createNewOption);
      return options;
    },
    onChange: (_, newOption) => onAccountingCustomerChange(newOption || undefined),
    disabled: disabled,
    virtualizeOptions: true,
    renderOption: option => {
      switch (option === null || option === void 0 ? void 0 : option.type) {
        case OptionType.CreateNew:
          {
            return /*#__PURE__*/_jsxs(Typography, {
              skin: "link",
              className: styles.newClientOption,
              children: [/*#__PURE__*/_jsx(Plus, {}), newClientText]
            });
          }
        case OptionType.Existing:
          {
            const emailAddress = option.customer.emailAddress();
            return /*#__PURE__*/_jsxs("div", {
              className: styles.existingClientOption,
              children: [/*#__PURE__*/_jsxs(Typography, {
                ellipsis: true,
                "data-testid": "first-line",
                children: [/*#__PURE__*/_jsx(Typography, {
                  as: "span",
                  children: option.customer.displayName()
                }), /*#__PURE__*/_jsx(Typography, {
                  as: "span",
                  weight: "light",
                  variant: "paragraph2",
                  skin: "secondary",
                  children: " (".concat(option.customer.customerName(), ")")
                })]
              }), emailAddress && /*#__PURE__*/_jsx(Typography, {
                ellipsis: true,
                weight: "light",
                variant: "paragraph2",
                "data-testid": "second-line",
                skin: "secondary",
                children: emailAddress
              })]
            });
          }
      }
    },
    getOptionSelected: (option, value) => {
      if (!value) return false;
      const isExistingCustomerType = option.type === OptionType.Existing && value.type === OptionType.Existing;
      const existingSelected = isExistingCustomerType && option.customer.id() === value.customer.id();
      const isNewCustomerType = option.type === OptionType.CreateNew && value.type === OptionType.CreateNew;
      return existingSelected || isNewCustomerType;
    },
    getOptionLabel: option => {
      switch (option === null || option === void 0 ? void 0 : option.type) {
        case OptionType.CreateNew:
          {
            return newClientText;
          }
        case OptionType.Existing:
          {
            return option.customer.formattedDisplay();
          }
      }
    },
    filterOptions: (options, _ref) => {
      let {
        inputValue
      } = _ref;
      const filtered = matchSorter(options, inputValue, {
        keys: [opt => opt.type === OptionType.Existing ? [opt.customer.displayName(), opt.customer.customerName(), opt.customer.emailAddress()] : []]
      });
      filtered.unshift(createNewOption);
      return filtered;
    },
    noOptionsText: "No ".concat(name, " customers"),
    loading: loading,
    textFieldProps: _objectSpread({
      placeholder: 'Not mapped'
    }, textFieldProps),
    selectOnFocus: true,
    disableClearable: false,
    multiple: false,
    freeSolo: false,
    onFocus: onInputFocus,
    onBlur: onInputBlur
  });
}